import React from 'react';
import { observer } from 'mobx-react';
import Select from 'react-select';

export default observer(({ field }) => (
    <div className="form-field" id={"form-select-" + field.id}>
        <div className="form-field-title">
            <label
                htmlFor={field.id}
                className="f7 db mb2 mt3 light-silver"
    >
      {field.label}
            </label>
        </div >
        <div className="form-field-input" >
            <Select
                {...field.bind() }
                options={field.extra}
                clearable={false}
                resetValue={[]}
                disabled={field.disabled}
            />
        </div>
    </div>
));



// WEBPACK FOOTER //
// ./src/components/forms/inputs/ReactSingleSelect.jsx